const baseURL = 'https://restaurante.mixkatalogo.com/';

export default baseURL;
